// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7cf3ed33","703":"fdebc3ca"}[chunkId] + ".chunk.js";
};